import { render, staticRenderFns } from "./SendCode.vue?vue&type=template&id=92169218&scoped=true&"
import script from "./script.js?vue&type=script&lang=js&"
export * from "./script.js?vue&type=script&lang=js&"
import style0 from "@/scss/login.scss?vue&type=style&index=0&id=92169218&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92169218",
  null
  
)

export default component.exports